import { render, staticRenderFns } from "./newsCoupon.vue?vue&type=template&id=0b94f312&scoped=true&"
import script from "./newsCoupon.vue?vue&type=script&lang=js&"
export * from "./newsCoupon.vue?vue&type=script&lang=js&"
import style0 from "./newsCoupon.vue?vue&type=style&index=0&id=0b94f312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94f312",
  null
  
)

export default component.exports